import { Box } from "@chakra-ui/react";
import { FixedCosts } from "../components/FixedCostsForm"; // Die FixedCosts-Komponente importieren

const FixedCostsPage = () => {
  return (
    <Box p={6}>
      <FixedCosts />
    </Box>
  );
};

export default FixedCostsPage;
